// SRAGCircle OPC - Mock Data for Frontend

export const companyInfo = {
  name: "SRAGCircle OPC",
  fullName: "Systems, Resources & Automations Group",
  tagline: "A SEC-registered Philippine corporation delivering integrated IT, security, electrical, and facilities solutions for modern organizations.",
  description: "From IT and network systems to security, power, and facility support, SRAGCircle OPC combines wholesale and retail trading with deep engineering expertise to deliver reliable, turnkey solutions.",
  logo: "https://customer-assets.emergentagent.com/job_809dfd65-fb81-47c1-9f5c-b2e55c213859/artifacts/gdlxp68v_SRAGCircle-transparent-website.png",
  logoLight: "https://customer-assets.emergentagent.com/job_sragcorp/artifacts/or6ui3f9_Screenshot%202026-01-17%20at%205.16.25%E2%80%AFPM.png",
  founded: "SEC-registered corporation",
  experience: "35+ years",
  location: "Metro Manila, Philippines"
};

export const mission = "To deliver quality work without shortcuts, professional service anchored on industry standards and best practices, and dependable equipment and accessories that enable truly worry-free operations and maintenance for every customer.";

export const vision = "To be the primary go-to company for organizations seeking not only equipment, parts, and accessories, but also value-adding technical expertise and support services that drive resilience, efficiency, and growth.";

export const whyChooseUs = [
  {
    id: 1,
    title: "SEC-Registered Corporation",
    description: "Professionally managed corporation based in Metro Manila, ensuring compliance and accountability."
  },
  {
    id: 2,
    title: "35+ Years Experience",
    description: "Multidisciplinary leadership team of engineers, lawyers, and technology professionals."
  },
  {
    id: 3,
    title: "End-to-End Solutions",
    description: "Complete capabilities: design, supply, installation, maintenance, and after-sales support."
  },
  {
    id: 4,
    title: "Broad Coverage",
    description: "From IT and automation to security, power, repairs, and facilities support."
  }
];

export const services = [
  {
    id: 1,
    slug: "it-network-systems",
    title: "IT & Network Systems",
    shortDescription: "Managed IT services, cybersecurity, cloud solutions, and network optimization.",
    fullDescription: "Managed IT services, cybersecurity solutions, cloud services and migration, network design and optimization, data management and backup, and IT consulting and strategy. Custom software and application development and computer upgrades or custom builds supported by reliable warranty and after-sales support.",
    icon: "Monitor",
    features: [
      "Managed IT Services",
      "Cybersecurity Solutions",
      "Cloud Services & Migration",
      "Network Design & Optimization",
      "Data Management & Backup",
      "IT Consulting & Strategy",
      "Custom Software Development",
      "Computer Upgrades & Custom Builds"
    ]
  },
  {
    id: 2,
    slug: "scada-automation",
    title: "SCADA & Automation",
    shortDescription: "Real-time monitoring, building management systems, and smart automation.",
    fullDescription: "SCADA systems for real-time monitoring and control, Building Management Systems (BMS), PLC-based control systems, and smart home automation. Industrial IoT and data analytics, plus ongoing system maintenance, support, and compliance with industry standards.",
    icon: "Cpu",
    features: [
      "SCADA Systems",
      "Building Management Systems (BMS)",
      "PLC-based Control Systems",
      "Smart Home Automation",
      "Industrial IoT & Data Analytics",
      "System Maintenance & Support",
      "Compliance with Industry Standards"
    ]
  },
  {
    id: 3,
    slug: "security-surveillance",
    title: "Security & Surveillance",
    shortDescription: "Integrated CCTV, access control, alarm systems, and manned security.",
    fullDescription: "Integrated security solutions combining CCTV, alarms, and access control into cohesive systems. Design, installation, maintenance, and 24/7 support options, alongside manned facility security services for commercial and institutional clients.",
    icon: "Shield",
    features: [
      "CCTV Systems",
      "Access Control Systems",
      "Alarm Systems",
      "Integrated Security Solutions",
      "24/7 Support Options",
      "Manned Facility Security",
      "Commercial & Institutional Security"
    ]
  },
  {
    id: 4,
    slug: "audio-visual-communications",
    title: "Audio Visual & Communications",
    shortDescription: "Conference room solutions, video conferencing, and digital signage.",
    fullDescription: "Integrated audio-visual solutions for conference rooms, schools, and large venues. Unified communication systems, professional audio, video conferencing and telepresence, digital signage, and ongoing maintenance and support.",
    icon: "Video",
    features: [
      "Conference Room Solutions",
      "Unified Communication Systems",
      "Professional Audio",
      "Video Conferencing & Telepresence",
      "Digital Signage",
      "Large Venue Solutions",
      "Ongoing Maintenance & Support"
    ]
  },
  {
    id: 5,
    slug: "electrical-power",
    title: "Electrical & Power Equipment",
    shortDescription: "Transformers, generators, UPS, and energy management solutions.",
    fullDescription: "Sales and distribution of transformers, switchgear, generators, UPS, and related power equipment. Energy management, installation and commissioning, preventive maintenance, emergency repairs, and system upgrades.",
    icon: "Zap",
    features: [
      "Transformers & Switchgear",
      "Generators & UPS",
      "Energy Management",
      "Installation & Commissioning",
      "Preventive Maintenance",
      "Emergency Repairs",
      "System Upgrades"
    ]
  },
  {
    id: 6,
    slug: "gps-fleet-tracking",
    title: "GPS & Fleet Tracking",
    shortDescription: "Real-time vehicle tracking, route optimization, and fleet management.",
    fullDescription: "Real-time vehicle tracking, route optimization, driver behavior monitoring, geofencing, and security alerts. Advanced fleet management software, asset tracking, diagnostics, and compliance reporting.",
    icon: "Navigation",
    features: [
      "Real-time Vehicle Tracking",
      "Route Optimization",
      "Driver Behavior Monitoring",
      "Geofencing & Security Alerts",
      "Fleet Management Software",
      "Asset Tracking",
      "Diagnostics & Compliance Reporting"
    ]
  },
  {
    id: 7,
    slug: "accessories-consumables",
    title: "IT & Electronics Accessories",
    shortDescription: "Hardware, peripherals, networking equipment, and consumables.",
    fullDescription: "Broad inventory of IT hardware, peripherals, networking equipment, electrical and electronics accessories, spare parts, and consumables like ink, toner, and cables.",
    icon: "Package",
    features: [
      "IT Hardware & Peripherals",
      "Networking Equipment",
      "Electrical Accessories",
      "Electronics Accessories",
      "Spare Parts",
      "Consumables (Ink, Toner, Cables)"
    ]
  },
  {
    id: 8,
    slug: "facilities-support",
    title: "Facilities Support Services",
    shortDescription: "Consultancy, equipment repair, maintenance, and janitorial services.",
    fullDescription: "Consultancy, system design and related engineering services. General equipment repair and maintenance for a wide range of commercial and industrial machinery. Facility manned security, general maintenance, housekeeping, and janitorial services, including tailored cleaning programs and building upkeep.",
    icon: "Building2",
    features: [
      "Consultancy & System Design",
      "Engineering Services",
      "Equipment Repair & Maintenance",
      "Building General Maintenance",
      "Housekeeping & Janitorial",
      "Tailored Cleaning Programs"
    ]
  },
  {
    id: 9,
    slug: "parts-accessories-consumables",
    title: "Parts, Accessories & Consumables",
    shortDescription: "Cables, connectors, power supplies, batteries, antennas, and specialized accessories.",
    fullDescription: "Ancillary items necessary for the operation, installation, support, or enhancement of equipment, which are not included in the main equipment package but are required for its efficient use. This category includes cables, connectors, power supplies, batteries, antennas, and other specialized or customized items or accessories required for proper installation, operation, maintenance, or upgrading of equipment.",
    icon: "Cog",
    features: [
      "Cables & Connectors",
      "Power Supplies & Batteries",
      "Antennas & Signal Equipment",
      "Specialized Accessories",
      "Installation Components",
      "Maintenance Parts",
      "Upgrade Components",
      "Custom & OEM Parts"
    ]
  }
];

export const industries = [
  {
    id: 1,
    title: "Commercial & Office Buildings",
    description: "IT infrastructure, security systems, and facilities management for modern workplaces."
  },
  {
    id: 2,
    title: "Industrial & Manufacturing",
    description: "SCADA, automation, power systems, and equipment maintenance for production facilities."
  },
  {
    id: 3,
    title: "Retail & Commercial Establishments",
    description: "Security, communications, and integrated solutions for customer-facing businesses."
  },
  {
    id: 4,
    title: "Residential & Mixed-Use",
    description: "Smart home automation, security, and facilities support for residential developments."
  }
];

export const contactInfo = {
  mobile: "(63) 926 036 6898",
  officePhone: "(63) 2 8477 0975",
  email: "contact@sragcircle.com",
  alternateEmails: ["srag.enterprise@gmail.com", "srag.enterprise@outlook.com"],
  city: "Metro Manila",
  country: "Philippines"
};

export const companyProfile = {
  overview: "SRAGCircle OPC is a SEC-registered corporation headquartered in Metro Manila, Philippines, engaged primarily in wholesale and retail trading of IT, computer, electrical and electronic equipment and related accessories, spare parts, and consumables.",
  leadership: "The company is managed by a multidisciplinary team of engineers, lawyers, and policy and technology enthusiasts with more than 35 years of experience in systems design, implementation, operations and maintenance, optimization, and vendor selection in local and international markets.",
  primaryBusiness: "Wholesale and retail trading of IT, computer, electrical and electronic equipment, accessories, spare parts, and consumables.",
  secondaryBusinesses: [
    "IT software applications and related IT services (managed IT, cybersecurity, cloud, networking, systems integration)",
    "Management consultancy and systems/engineering consulting",
    "Repairs of computers, communications equipment, and general commercial and industrial equipment",
    "Security facility sales and installation (CCTV, access control, alarm systems) and manned security services",
    "Combined facilities support activities, including general maintenance, housekeeping, janitorial, and cleaning services"
  ]
};

export const navLinks = [
  { href: "/", label: "Home" },
  { href: "/about", label: "About Us" },
  { href: "/services", label: "Products & Services" },
  { href: "/contact", label: "Contact Us" }
];
